import { atom } from 'recoil';
export const localContractResultBufferAtom = atom({
    key: 'claimListResult/localContractResultBufferAtom',
    default: null,
});
export const claimDetailAtom = atom({
    key: 'claimDetail',
    default: {},
});
export const claimListResultAtom = atom({
    key: 'claimListResult',
    default: null,
});
export const claimListResultPageinationAtom = atom({
    key: 'claimListResult/pagination',
    default: {
        pageIndex: 0,
    },
});
export const claimCreationShowPolicySidebar = atom({
    key: 'createClaim/showPolicySideBar',
    default: false,
});
export const selectedPolicyResultAtom = atom({
    key: 'selectedContractResult',
    default: null,
});
export const selectedPartyResultAtom = atom({
    key: 'selectedPartyResult',
    default: null,
});
export const localContractVehiclesAtom = atom({
    key: 'localContractVehicles',
    default: [],
});
export const localSelectedContractVehicleAtom = atom({
    key: 'localSelectedContractVehicle',
    default: undefined,
});
export const localReserveAtom = atom({
    key: 'localReserve',
    default: {
        currency: 'EUR',
    },
});
